/** Situações da forma de pagamento */
export interface FormaPagamentoSituacao {
    id: number;
    nome: string;
}

export const formaPagamentoSituacaoAtiva: FormaPagamentoSituacao = {id: 1, nome: 'Ativa'};
export const formaPagamentoSituacaoInativa: FormaPagamentoSituacao = {id: 2, nome: 'Inativa'};

export const formaPagamentoSituacoes: FormaPagamentoSituacao[] = [
    formaPagamentoSituacaoAtiva,
    formaPagamentoSituacaoInativa
];

/** Verifica se a situação informada é igual a Ativa */
export function isFormaPagamentoSituacaoAtiva(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === formaPagamentoSituacaoAtiva.id;
}

/** Verifica se a situação informada é igual a Inativa */
export function isFormaPagamentoSituacaoInativa(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === formaPagamentoSituacaoInativa.id;
}
